export type ChartMode = 'individual' | 'group';

export type ChartModeStatePatch = {
  selectedSensors: string[];
  pendingSensors: string[];
  individualModeSensors: string[];
  groupModeSensors: string[];
  channelsToFetch: string[];
};

export function buildChartModeStatePatch(
  targetMode: ChartMode,
  currentMode: ChartMode,
  selectedSensors: string[],
  savedIndividual: string[],
  savedGroup: string[]
): ChartModeStatePatch {
  if (targetMode === 'group') {
    const individualModeSensors = currentMode === 'individual' ? selectedSensors : savedIndividual;

    if (savedGroup.length > 0) {
      return {
        selectedSensors: savedGroup,
        pendingSensors: savedGroup,
        individualModeSensors,
        groupModeSensors: savedGroup,
        channelsToFetch: savedGroup,
      };
    }

    if (selectedSensors.length > 3) {
      const limitedSensors = selectedSensors.slice(0, 3);
      return {
        selectedSensors: limitedSensors,
        pendingSensors: limitedSensors,
        individualModeSensors,
        groupModeSensors: limitedSensors,
        channelsToFetch: limitedSensors,
      };
    }

    return {
      selectedSensors,
      pendingSensors: selectedSensors,
      individualModeSensors,
      groupModeSensors: selectedSensors,
      channelsToFetch: [],
    };
  }

  const groupModeSensors = currentMode === 'group' ? selectedSensors : savedGroup;
  if (savedIndividual.length > 0 && currentMode === 'group') {
    return {
      selectedSensors: savedIndividual,
      pendingSensors: savedIndividual,
      individualModeSensors: savedIndividual,
      groupModeSensors,
      channelsToFetch: savedIndividual,
    };
  }

  return {
    selectedSensors,
    pendingSensors: selectedSensors,
    individualModeSensors: savedIndividual,
    groupModeSensors,
    channelsToFetch: [],
  };
}
